type IconProps = React.HTMLAttributes<SVGElement>;

export const SwitchIcon = (props: IconProps) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="26" height="14" viewBox="0 0 26 14" fill="none" {...props}>
    <path
      d="M8.56592 0.5C8.28978 0.5 8.06592 0.723858 8.06592 1C8.06592 1.27614 8.28978 1.5 8.56592 1.5L8.56592 0.5ZM8.56592 1L8.56592 1.5H20.5659V1V0.5H8.56592L8.56592 1ZM22.5659 3H22.0659V13H22.5659H23.0659V3H22.5659ZM20.5659 1V1.5C21.3943 1.5 22.0659 2.17157 22.0659 3H22.5659H23.0659C23.0659 1.61929 21.9466 0.5 20.5659 0.5V1Z"
      fill="currentColor"
    />
    <path
      d="M17.5044 13.0039L5.50439 13.0039C4.39982 13.0039 3.50439 12.1085 3.50439 11.0039L3.50439 1.00391"
      stroke="currentColor"
      stroke-linecap="round"
    />
    <path
      d="M25.3346 10.1549L22.5005 12.9739L19.6663 10.1549"
      stroke="currentColor"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M0.665626 3.83173L3.50928 1.0033L6.35293 3.83173"
      stroke="currentColor"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);
